import { Component, OnInit } from "@angular/core";
import { LoginModel } from "src/app/core/endpoints/models/login.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "src/app/core/services/toast.service";
import { Router } from "@angular/router";
import { ApiService } from "src/app/core/services/api.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { AuthService } from "src/app/core/endpoints/auth.service";

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
	public loading = false;
	public forgotten = false;
	public register = false;
	versionApp:any = "";

	public formLogin: FormGroup = this.fb.group({
		email: ["", [Validators.required, Validators.email]],
		password: ["", Validators.required],
	});

	email = "";

	constructor(
		private fb: FormBuilder,
		private toast: ToastService,
		private router: Router,
		private apiService: ApiService,
		private auth: AuthenticationService
	) {
		this.loadVersion();
    	document.body.classList.remove('sidebar-static');
	}

	ngOnInit(): void {
		this.versionApp = localStorage.getItem('versionApp');
		let user = 	this.getUser();
		if (user){
			this.getUserData();
		}
	}
	/**
	 * Chequear sesion
	 * @returns
	 */

	getUser() {
		return AuthService.isLogged();
	}

	

	public getUserData() {
		this.apiService.getEntity("user").subscribe({
			next: (result) => {
				if (result.user){
					this.router.navigate(["/app"]);
					this.apiService.addEntity("users-logs").subscribe({});
    				document.body.classList.add('sidebar-static');
				}else{
    				document.body.classList.remove('sidebar-static');
					AuthService.removeAuthToken();
				}
			},
			error: (err) => {
			},
			complete: () => {},
		});
	}

	/**
	 * Enviar formulario de inicio de sesión
	 * @returns
	 */
	public login() {
		if (this.formLogin.invalid || this.loading) return;
		const loginModel: LoginModel = this.formLogin.value;

		this.loading = true;

		this.apiService
			.login(
				this.formLogin.get("email")?.value,
				this.formLogin.get("password")?.value
			)
			.subscribe({
				next: (result) => {
					this.apiService.setToken(result.access_token);
					this.auth.login(result.access_token);
					this.getUserLogin();
				},
				error: async (error) => {
					this.loading = false;
				},
				complete: () => {
					setTimeout(() => {
						this.loading = false;
					}, 1000);
				},
			});
	}

	
	public async getUserLogin() {
		this.loading = true;
		this.apiService.getEntity("user").subscribe({
			next: (result) => {
				AuthService.setDataUser(result.user);
				this.router.navigate(["app"]);
    			document.body.classList.add('sidebar-static');
			},
			error: (err) => {
    				document.body.classList.remove('sidebar-static');
						this.loading = false;
			},
			complete: () => {
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			},
		});
	}

	/**
	 * Abrir modal recuperar contraseña
	 */
	public showForgotten() {
		this.forgotten = true;
		this.email = "";
	}

	/**
	 * Envio formulario recuperar contraseña
	 * @returns
	 */
	public async resetPassword() {
		this.email = this.email.trim();
		if (!this.email || this.loading) return;

		const validate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
			this.email
		);

		if (!validate) {
			const message1 = "Formato incorrecto";
			const message2 = "Introduzca email válido";
			return this.toast.show(message1, message2, "warn");
		}

		this.loading = true;
		this.apiService.forgotPassword(this.email).subscribe({
			next: () => {
				const message1 = "Email de recuperación enviado";
				this.toast.show(message1);
			},
			error: (e) => {
				this.loading = false;
				const message3 = "Error intentando enviar el email de recuperación";

				let msjError = message3;

				if (e.error === "email_error") {
					const message3 = "Revisa tu bandeja de entrada";
					msjError = message3;
				}

				const message2 = "Error";

				this.toast.show(message2, msjError, "error");
			},
			complete: () => {
				this.loading = false;
				this.email = "";
				this.forgotten = false;
			},
		});
	}

	loadVersion(){
		this.apiService.getEntity('version').subscribe({
		  next: (response) => {
			this.versionApp = response;
			localStorage.setItem('versionApp',this.versionApp);
		  }
		});
	}
}
